<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong>
                        Quiz Response
                    </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row justify="center">
                <v-col cols="12" sm="3" md="3">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete rounded outlined dense v-model="ay" color="#0F2027" required :items="aylist" item-text="ay" item-value="id" label="Academic year" return-object />
                </v-col>
                <v-col cols="12" sm="3" md="3">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="crs" item-value="crs_id" :items="crs_list" item-text="crs_name" label="Subject" outlined />
                </v-col>
                <v-btn class="button mt-9" v-if="crs" @click="getResponseData()">Quiz Response</v-btn>
            </v-row>
        </v-card>
        <v-card v-if="quiz_list!=''" class="box">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong>
                        Quiz Response Data
                    </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-col cols="12" sm="12" md="12">
                <v-data-table :headers="headers" :items="quiz_list" dense class="elevation-1 mytable">
                    <template v-slot:item.action="{ item }">
                        <v-btn icon @click="getquizquestion(item.qid)"> <v-icon color="black">mdi-eye</v-icon></v-btn>
                    </template>
                    <template v-slot:item.response="{ item }">
                        <v-btn small class="button" @click="getStudentResponseData(item.qid)"> View Response</v-btn>
                    </template>
                </v-data-table>
            </v-col>
        </v-card>
        <v-dialog v-model="dialog" persistent max-width="1600px">
            <v-card>
                <v-toolbar class="toolbar" flat dense>
                    <v-toolbar-title>
                        <strong>
                            View Quiz Questions
                        </strong>
                    </v-toolbar-title>
                </v-toolbar>
                <v-card class="box">
                    <v-col cols="12" sm="12" md="12">
                        <v-simple-table dense class="elevation-1 mytable">
                            <thead>
                                <tr>
                                    <th>Sr. No.</th>
                                    <th>Chapter</th>
                                    <th>Quiz Type</th>
                                    <th>Question</th>
                                    <th>Question file</th>
                                    <th>Weightage</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="q in question_info" :key="q.id">
                                    <td>{{q.srno}}</td>
                                    <td>{{q.chapter}}</td>
                                    <td>{{q.quiztype}}</td>
                                    <td>
                                        <span v-if="q.question" v-html="q.question">
                                            {{ q.question }}
                                        </span>
                                    </td>
                                    <td>
                                        <span v-if="q.filepath">
                                            <a class="p-2" :href="aws_path+q.filepath+q.filename" target="blank">
                                                <v-tooltip top>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-btn icon v-if="q.filepath!==null" v-bind="attrs" v-on="on"> <v-icon color="black">mdi-eye</v-icon></v-btn>
                                                    </template>
                                                    <span>
                                                        View Question File!!!
                                                    </span>
                                                </v-tooltip>
                                            </a>
                                        </span>
                                        <span v-else>
                                            --
                                        </span>
                                    </td>
                                    <td>
                                        {{q.weightage}}
                                    </td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </v-col>
                </v-card>
                <v-row dense justify="center">
                    <v-btn class="button" @click="dialog = false">Close</v-btn>
                </v-row>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog_response" persistent max-width="1600px">
            <v-card>
                <v-toolbar class="toolbar" flat dense>
                    <v-toolbar-title>
                        <strong>
                            View Response
                        </strong>
                    </v-toolbar-title>
                </v-toolbar>
                <v-card class="box">
                <v-toolbar  flat dense>
                   
                            <v-btn  color="error" dark class="space" @click="generateCartPdf" ><v-icon>mdi-file-pdf-box</v-icon></v-btn>
                            <download-excel class="mar"
                                :data   = "responsedata"
                                :fields = "table_fields"
                                worksheet = "Student_List"
                                name    = "Student_List.xls">
                                <v-btn color="success" dark class="" @click="fnExcelReport('my-table-id', 'Quiz Response')" > <v-icon dark>mdi-file-excel</v-icon>  </v-btn>
                            </download-excel>
                    
                    <v-spacer></v-spacer>
                    <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details> </v-text-field>
                </v-toolbar>
                    <v-col cols="12" sm="12" md="12">
                        <v-data-table :headers="headers1" :items="responsedata" dense class="elevation-1 mytable" id="my-table-id" :search="search">
                            <template v-slot:item.response="{ item }">
                                <span v-if="item.status == 'Present'">
                                    <v-btn icon> <v-icon color="black" @click="getAnswer(item.quizscheduling,item.learner)">mdi-eye</v-icon></v-btn>
                                </span>
                                <span v-else>
                                    --
                                </span>
                            </template>
                        </v-data-table>
                    </v-col>
                </v-card>
                <v-row dense justify="center">
                    <v-btn class="button" @click="dialog_response = false">Close</v-btn>
                </v-row>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog_response_answer" persistent max-width="1500px">
            <v-card>
                <v-toolbar class="toolbar" flat dense>
                    <v-toolbar-title>
                        <strong>
                            View Student Answer
                        </strong>
                    </v-toolbar-title>
                </v-toolbar>
                <v-card class="box">
                    <v-col cols="12" sm="12" md="12">
                        <v-data-table :headers="headers2" :items="response_answer" dense class="elevation-1 mytable" :search="search">
                         <template v-slot:item.question="{ item }">
                          <span  v-html="item.question">
                                        {{ item.question }}
                            </span>
                         </template>
                        <template v-slot:item.file="{ item }">
                                <span v-if="item.file != '--'">
                                    <a class="p-2" :href="item.file" target="blank">
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn icon v-bind="attrs" v-on="on"> <v-icon color="black">mdi-eye</v-icon></v-btn>
                                                </template>
                                                <span>
                                                    View Question File!!!
                                                </span>
                                            </v-tooltip>
                                        </a>
                                </span>
                                <span v-else>
                                    --
                                </span>
                            </template>
                            <template v-slot:item.stud_ans="{ item }">
                                <span v-if="item.quiztype != 'MCQ'">
                                    <v-btn icon @click="viewans(item.stud_ans)"> <v-icon color="black">mdi-eye</v-icon></v-btn>
                                </span>
                                <span v-else>
                                    {{item.stud_ans}}
                                </span>
                            </template>
                            <template v-slot:item.stud_file="{ item }">
                                <span v-if="item.stud_file != '--'">
                                    <a class="p-2" :href="item.stud_file" target="blank">
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn icon v-bind="attrs" v-on="on"> <v-icon color="black">mdi-eye</v-icon></v-btn>
                                                </template>
                                                <span>
                                                    View Student Ans. File!!!
                                                </span>
                                            </v-tooltip>
                                        </a>
                                </span>
                                <span v-else>
                                    --
                                </span>
                            </template>
                            <template v-slot:item.evaluted="{ item }">
                                <span v-if="item.evaluted">
                                    <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                                </span>
                                <span v-else>
                                    <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                                </span>
                            </template>
                        </v-data-table>
                    </v-col>
                </v-card>
                <v-row dense justify="center">
                    <v-btn class="button" @click="dialog_response_answer = false">Close</v-btn>
                </v-row>
            </v-card>
        </v-dialog>
         <v-dialog v-model="diaglog_ans" persistent max-width="600px">
            <v-card>
                <v-toolbar class="toolbar" flat dense>
                    <v-toolbar-title>
                        <strong>
                            View Student Answer
                        </strong>
                    </v-toolbar-title>
                </v-toolbar>
                <v-card class="box">
                    <v-col cols="12" sm="12" md="12">
                    {{stud_ans}}
                    </v-col>
                </v-card>
                <v-row dense justify="center">
                    <v-btn class="button" @click="diaglog_ans = false">Close</v-btn>
                </v-row>
            </v-card>
         </v-dialog>
    </div>
</template>
<script>
import jsPDF from 'jspdf'
import 'jspdf-autotable'
    import axios from "axios";
    import { VueMathjax } from "vue-mathjax";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        components: {
            "vue-mathjax": VueMathjax,
        },
        data() {
            return {
                snackbar_msg: "",
                color: "",
                snackbar: false,
                search: null,
                overlay: false,
                crs_list: null,
                crs: null,
                ay: null,
                aylist: null,
                quiz_list: [],
                question_info: [],
                aws_path: null,
                dialog: false,
                dialog_response: false,
                dialog_response_answer: false,
                responsedata: [],
                response_answer: [],
                diaglog_ans:false,
                stud_ans:null,
                table_fields: {
                    'Sr. No':'srno',
                    'GR. Number':'reg_no',
                    'Student Name':'lname',
                    'Division':'division',
                    'Marks':'marks',
                    'Time Taken':'duration'
                },
                headers: [
                    { text: "Sr. No.", value: "srno" },
                    { text: "Division", value: "division" },
                    { text: "Title", value: "title" },
                    { text: "Created Date", value: "created_date" },
                    { text: "Start Date", value: "start_date" },
                    { text: "Status", value: "status" },
                    { text: "Total Marks", value: "total_marks" },
                    { text: "View Questions", value: "action" },
                    { text: "View Answer", value: "response" },
                ],
                headers1: [
                    { text: "Sr. No.", value: "srno" },
                    { text: "PRN No", value: "reg_no" },
                    { text: "Learner Name", value: "lname" },
                    { text: "Division", value: "division" },
                    { text: "Attendance", value: "status" },
                    { text: "Total Marks", value: "marks" },
                    { text: "Time Taken", value: "duration" },
                    { text: "View Response", value: "response" },
                ],
                headers2: [
                    { text: "Sr. No.", value: "srno" },
                    { text: "Chapter", value: "chapter" },
                    { text: "Quiz Type", value: "quiztype" },
                    { text: "Question", value: "question" },
                    { text: "Question File", value: "file" },
                    { text: "Question Correct Ans", value: "correct_ans" },
                    { text: "Student Ans", value: "stud_ans" },
                    { text: "Student Ans File", value: "stud_file" },
                    { text: "Is Evaluated", value: "evaluted" },
                ],
            };
        },
        methods: {
            generateCartPdf() {
            const doc = new jsPDF()
            doc.autoTable({
            theme: 'grid',
            body:this.responsedata,
            columns: [
                { header: 'Sr. no', dataKey: 'srno' },
                { header: 'GR. Number', dataKey: 'reg_no' },
                { header:'Student Name', dataKey:'lname'},
                { header:'Division', dataKey:'division'},
                { header:'Marks', dataKey:'marks'},
                { header:'Time Taken', dataKey:'duration'},
            ],
            })
            doc.save('Test_Student_List.pdf')
            },
            fnExcelReport(id, name) {
                var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
                tab_text = tab_text + "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
                tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
                tab_text = tab_text + "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
                tab_text = tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
                tab_text = tab_text + "<table style='border-collapse:collapse;' border='1'>";
                var exportTable = $("#" + id).clone();
                exportTable.find("input").each(function (index, elem) {
                    $(elem).remove();
                });
                exportTable.find('th, td').each(function() {
                    $(this).css('border', '1px solid black');
                });
                tab_text = tab_text + exportTable.html();
                tab_text = tab_text + "</table></body></html>";
                var fileName = name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

                //Save the file
                // var blob = new Blob([tab_text], {
                //     type: "application/vnd.ms-excel;charset=utf-8",
                // });
                // window.saveAs(blob, fileName);
                const blob = new Blob([tab_text], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
       const filename = name+'.xls';

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        // For IE
        window.navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // For modern browsers
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
      }
            },
            viewans(stud_ans)
            {
                this.stud_ans = stud_ans
                this.diaglog_ans = true
            },
            getAnswer(quizscheduling, learner) {
                const data = {
                    ay: this.ay.id,
                    qid: quizscheduling,
                    lid: learner,
                };
                axios
                    .post("/QuizQuestionBank/getAnswer", data)
                    .then((res) => {
                        this.response_answer = res.data.response_answer;
                        this.aws_path = res.data.aws_path;
                        this.dialog_response_answer = true;
                    })
                    .catch((error) => {
                        window.console.log(error);
                        this.showSnackbar("#b71c1c", "Something went wrong !!!");
                    })
                    .finally(() => {
                        //close loader
                    });
            },
            getStudentResponseData(item) {
                const data = {
                    ay: this.ay.id,
                    qid: item,
                };
                axios
                    .post("/QuizQuestionBank/getStudentResponseData", data)
                    .then((res) => {
                        this.responsedata = res.data.responsedata;
                        this.aws_path = res.data.aws_path;
                        this.dialog_response = true;
                    })
                    .catch((error) => {
                        window.console.log(error);
                        this.showSnackbar("#b71c1c", "Something went wrong !!!");
                    })
                    .finally(() => {
                        //close loader
                    });
            },
            getquizquestion(item) {
                const data = {
                    qid: item,
                };
                axios
                    .post("/QuizQuestionBank/getquizquestion", data)
                    .then((res) => {
                        this.question_info = res.data.question_info;
                        this.aws_path = res.data.aws_path;
                        this.dialog = true;
                    })
                    .catch((error) => {
                        window.console.log(error);
                        this.showSnackbar("#b71c1c", "Something went wrong !!!");
                    })
                    .finally(() => {
                        //close loader
                    });
            },
            getResponseData() {
                const data = {
                    ay: this.ay.id,
                    crs_id: this.crs,
                };
                axios
                    .post("/QuizQuestionBank/getResponseData", data)
                    .then((res) => {
                        this.quiz_list = res.data.quiz_list;
                    })
                    .catch((error) => {
                        window.console.log(error);
                        this.showSnackbar("#b71c1c", "Something went wrong !!!");
                    })
                    .finally(() => {
                        //close loader
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            getCourse() {
                axios
                    .post("/QuizQuestionBank/getCourse")
                    .then((res) => {
                        this.crs_list = res.data.crs_list;
                        this.ay = res.data.curr_ay;
                        this.aylist = res.data.ay_list;
                    })
                    .catch((error) => {
                        window.console.log(error);
                        this.showSnackbar("#b71c1c", "Something went wrong !!!");
                    })
                    .finally(() => {
                        //close loader
                    });
            },
        },
        mounted() {
            this.getCourse();
        },
    };
</script>
<style scoped>
    .mytable /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
    a {
        text-decoration: none;
    }
    .mytable /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
    tr,
    td,
    th {
        border: 1px solid #ccc;
        text-align: center;
    }
    tr,
    tbody {
        border-bottom: 1px solid #ccc;
        border: 1px solid #ccc;
    }
    td {
        margin: 0.3rem !important;
        padding: 0.4rem !important;
    }
    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
        }
        td + td,
        th + th {
            width: auto;
        }
    }
    v-simple-table {
        white-space: nowrap !important;
        text-align: center;
    }
</style>
